import { render, staticRenderFns } from "./RecentStudy.vue?vue&type=template&id=63bf41b4&scoped=true"
import script from "./RecentStudy.vue?vue&type=script&lang=js"
export * from "./RecentStudy.vue?vue&type=script&lang=js"
import style0 from "./RecentStudy.vue?vue&type=style&index=0&id=63bf41b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bf41b4",
  null
  
)

export default component.exports